import {
  Box,
  Flex,
  Link,
  Button,
  Text,
  useColorModeValue,
  Stack,
  useColorMode,
  MenuList,
  Center,
  Avatar,
  MenuDivider,
  MenuItem,
  MenuButton,
  Menu,
} from "@chakra-ui/react";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import axios from "axios";
import { Link as ReactRouterLink } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { useAccount, useUser } from "../lib/accountContext";
import { useState } from "react";
import toast, { Toaster } from 'react-hot-toast';

const NavLink = ({ children }) => (
  <Link
    px={2}
    py={1}
    rounded={"md"}
    _hover={{
      textDecoration: "none",
      bg: useColorModeValue("gray.200", "gray.700"),
    }}
    href={"#"}
  >
    {children}
  </Link>
);

export default function Nav() {
  const { colorMode, toggleColorMode } = useColorMode();
  const account = useAccount();

  const [creatingSession, setCreatingSession] = useState(false);

  const checkout = async () => {
    setCreatingSession(true);
    const res = await axios
      .post("/create-payment-checkout-session")
      .catch((e) => {
        console.error(e);
        setCreatingSession(false);
        toast.error("Sorry we had an issue creating the checkout session. Please try again later.");
      });
    if (res.data) window.location.href = res.data.checkoutUrl;
  };


  const doSignOut = () => {
    signOut(getAuth());
  };
  return (
    <Box boxShadow="xs" px={5}>
      <Flex h={20} alignItems={"center"} justifyContent={"space-between"}>
        <Link as={ReactRouterLink} to="/" style={{ textDecoration: "none" }}>
          <Text fontSize="2xl" fontWeight="700">
            wordbase.ai
          </Text>
        </Link>
        <Flex alignItems={"center"}>
          <Stack direction={"row"} spacing={5}>
            <Button onClick={toggleColorMode}>
              {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
            </Button>
            {account?.user ? (
              <Menu>
                <MenuButton
                  as={Button}
                  rounded={"full"}
                  variant={"link"}
                  cursor={"pointer"}
                  minW={0}
                >
                  {account.user.photoURL ? (
                    <img
                      referrerPolicy="no-referrer"
                      width="35px"
                      height="35px"
                      alt="avatar"
                      src={account.user && account.user.photoURL}
                      style={{ borderRadius: "50%", border: "1px solid #e2e8f0" }}
                    />
                  ) : (
                    <Avatar
                      w="35px"
                      h="35px"
                      bg="linear-gradient(to bottom left, #7928CA, #FF0080)"
                      color="white"
                      name={account.user.displayName}
                    ></Avatar>
                  )}
                </MenuButton>
                <MenuList alignItems={"center"}>
                  <Stack px={3} textAlign="center">
                    <p>{account.user.email}</p>
                    {account.isFreeSubscription && (
                      <div>
                        <ReactRouterLink to="/open-billing">
                          <MenuItem>Billing Portal</MenuItem>
                        </ReactRouterLink>
                      </div>

                    )}
                  </Stack>
                  <MenuDivider />
                  {account.isSubscribed && !account.isFreeSubscription && (
                    <ReactRouterLink to="/open-billing">
                      <MenuItem>Subscription Settings</MenuItem>
                    </ReactRouterLink>
                  )}
                  <MenuItem onClick={doSignOut}>Sign Out</MenuItem>
                </MenuList>
              </Menu>
            ) : (
              <>
                <ReactRouterLink to="/signin">
                  <Button variant="outline">Sign In</Button>
                </ReactRouterLink>
                <ReactRouterLink to="/signup">
                  <Button colorScheme="purple">Sign Up</Button>
                </ReactRouterLink>
              </>
            )}
          </Stack>
        </Flex>
      </Flex>
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </Box>
  );
}
